import tutorials from './tutorials/routes';

export default [tutorials];
